// useAuth hook - access current auth state

import { useContext } from "react";
import { AuthContext } from "./auth-context";

/**
 * Access current authentication state
 *
 * @returns {Object} Auth state
 * @returns {User | null} user - Current authenticated user or null
 * @returns {boolean} isLoaded - Whether initial auth check is complete
 *
 * @throws {Error} If used outside AuthProvider
 *
 * @example
 * function MyComponent() {
 *   const { user, isLoaded } = useAuth();
 *
 *   if (!isLoaded) return <Loading />;
 *   if (!user) return <SignIn />;
 *
 *   return <div>Welcome {user.firstName}</div>;
 * }
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
}
